import {Tag} from "~/components/tag/Tag";

type SupplierScoreTagProps = {
    /** The entity's `confidence`, 0–100 */
    score: number;
};

/** The supplier's score as a coloured badge: green from 80, amber from 60, red below. */
export function SupplierScoreTag({score}: SupplierScoreTagProps) {
    return (
        <Tag
            size="small"
            label={Math.round(score)}
            color={score >= 80 ? 'success' : score >= 60 ? 'warning' : 'error'}
        />
    );
}
